import { Columns, Column, useResponsiveValue } from 'braid-design-system';
import type React from 'react';

import { Skeleton } from '../Skeleton/Skeleton';

interface JobActionsLoaderProps {
  isDraft?: boolean;
}

export const JobActionsLoader: React.FC<
  React.PropsWithChildren<JobActionsLoaderProps>
> = ({ isDraft = false }) => {
  const responsiveValue = useResponsiveValue();
  const columnWidth = responsiveValue({
    mobile: 'content',
    desktop: 'content',
  }) as undefined | 'content';

  return (
    <Columns space={['medium', 'small']} align="right">
      {Array(isDraft ? 2 : 4)
        .fill(undefined)
        .map((_, index) => (
          <Column key={index} width={columnWidth}>
            <Skeleton loading numberOfCharacters={3} height={25} />
          </Column>
        ))}
    </Columns>
  );
};
